import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { formatMoney } from '../../utils/format';
import { Icon } from '../../components/icons';

interface BalanceVerificationDTO {
    expectedBalance: number;
    calculatedBalance: number;
    difference: number;
}

const BalanceVerification: React.FC<{ refresh: boolean }> = ({ refresh }) => {
    const [balanceData, setBalanceData] = useState<BalanceVerificationDTO | null>(null);

    useEffect(() => {
        axios.get<BalanceVerificationDTO>('/api/payments/balance-verification')
            .then(response => {
                setBalanceData(response.data);
            })
            .catch(error => {
                console.error('Error fetching balance verification', error);
            });
    }, [refresh]);

    if (!balanceData) return null;

    const isMatch = Math.abs(balanceData.difference) < 0.01;

    return (
        <section className="stat-grid" aria-label="Salda konta">
            <div className="stat-card surface">
                <div className="stat-label">Saldo ogółem</div>
                <div className="stat-value">{formatMoney(balanceData.calculatedBalance, { fixed: true })}</div>
                <div className="stat-hint">Wyliczone na podstawie transakcji w systemie</div>
            </div>

            <div className="stat-card surface">
                <div className="stat-label">Saldo oczekiwane</div>
                <div className="stat-value">{formatMoney(balanceData.expectedBalance, { fixed: true })}</div>
                <div className="stat-hint">Według ostatnio wczytanego wyciągu bankowego</div>
            </div>

            <div className={`stat-card surface ${isMatch ? 'is-ok' : 'is-warn'}`}>
                <div className="stat-label">Weryfikacja salda</div>
                <div className="stat-value">
                    {isMatch ? 'Zgodne' : formatMoney(balanceData.difference, { fixed: true, signed: true })}
                </div>
                <div className="stat-hint">
                    <Icon name={isMatch ? 'checkCircle' : 'alert'} size={16} />
                    {isMatch ? 'Stan konta zgadza się z wyciągiem' : 'Wykryto rozbieżność między saldami'}
                </div>
            </div>
        </section>
    );
};

export default BalanceVerification;
